<div class="canvas-sidebar" [class.has-traces]="!!selectedCanvasId" (contextmenu)="onContextMenu($event)">
  <!-- Canvases panel (always visible) -->
  <div class="sidebar-panel canvases-panel">
    <div class="sidebar-header">
      <span class="sidebar-title">Canvases</span>
      <ddc-command-invoker
        [args]="argsForNewCanvas()"
        [command]="newCanvasCommand"
        (executed)="onHeaderCommandExecuted($event)"
      />
    </div>

    @if (isLoading) {
      <div class="sidebar-loading">
        <mat-spinner diameter="30"></mat-spinner>
      </div>
    } @else if (canvases.length === 0) {
      <div class="sidebar-empty">
        <mat-icon class="empty-icon">dashboard_customize</mat-icon>
        <span>No canvases yet</span>
        <button mat-stroked-button (click)="onCreateCanvas()">Create one</button>
      </div>
    } @else {
      <div class="sidebar-list">
        @for (canvas of canvases; track canvas.id) {
          <ddc-canvas-row
            [canvas]="canvas"
            [isDirty]="dirtyCanvasIds.has(canvas.id)"
            [isEditing]="canvas.id === editingCanvasId"
            [isSelected]="canvas.id === selectedCanvasId"
            (deleteCanvas)="onDeleteCanvas($event)"
            (duplicateCanvas)="onDuplicateCanvas($event)"
            (renameCanvas)="renameCanvas.emit($event)"
            (selectCanvas)="onSelectCanvas($event)"
          />
        }
      </div>
    }
  </div>

  <!-- Traces panel (visible when a canvas is selected) -->
  @if (selectedCanvasId) {
    <div class="sidebar-panel traces-panel">
      <div class="sidebar-header">
        <span class="sidebar-title">Traces</span>
        <ddc-command-invoker
          [args]="argsForDeleteAllTraces()"
          [command]="deleteAllTracesCommand"
          (executed)="onHeaderCommandExecuted($event)"
        />
      </div>

      @if (isLoadingTraces) {
        <div class="sidebar-loading">
          <mat-spinner diameter="30"></mat-spinner>
        </div>
      } @else if (traces.length === 0) {
        <div class="sidebar-empty">
          <mat-icon class="empty-icon">history</mat-icon>
          <span>No runs yet</span>
        </div>
      } @else {
        <div class="sidebar-list">
          @for (trace of traces; track trace.id) {
            <div class="trace-row" [class.selected]="trace.id === selectedTraceId" (click)="onSelectTrace(trace)">
              <mat-icon [class]="getTraceStatusClass(trace.status)">
                {{ getTraceStatusIcon(trace.status) }}
              </mat-icon>
              <div class="trace-info">
                <span class="trace-label">Run #{{ trace.id }}</span>
                <span class="trace-date">{{ trace.created_at | date: 'short' }}</span>
              </div>
              <button
                class="trace-delete-btn"
                mat-icon-button
                matTooltip="Delete trace"
                (click)="onDeleteTrace($event, trace)"
              >
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          }
        </div>
      }
    </div>
  }
</div>

<!-- Sidebar context menu -->
<div
  #menuTriggerEl
  class="context-menu-trigger"
  [matMenuTriggerFor]="sidebarContextMenu"
  [style.left.px]="contextMenuPosition.x"
  [style.top.px]="contextMenuPosition.y"
></div>
<mat-menu #sidebarContextMenu="matMenu" class="canvas-context-menu">
  <button mat-menu-item (click)="onCreateCanvas()">
    <mat-icon>add</mat-icon>
    <span>New Canvas</span>
  </button>
  <button mat-menu-item (click)="onCollapseAll()">
    <mat-icon>unfold_less</mat-icon>
    <span>Collapse All</span>
  </button>
  <button mat-menu-item (click)="onRefresh()">
    <mat-icon>refresh</mat-icon>
    <span>Refresh List</span>
  </button>
</mat-menu>
